import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import { SubtitleContext } from "../../contexts/SubtitleContext";
import TranslationsView from "./TranslationsView";
import { Button, Icon } from "semantic-ui-react";

class TranslationsMain extends Component {
  render() {
    return (
      <div
        className="position-relative"
        style={{
          height: "100%",
          overflow:'hidden',
          backgroundColor: "rgb(223, 221, 224)",
        }}
      >
        <SubtitleContext.Consumer>
          {(context) => <TranslationsView context={context} />}
        </SubtitleContext.Consumer>

        <div
          className="position-absolute"
          style={{ top: "10px", left: "15px" }}
        >
          <Link to={`/editor`} target="_self">
            <Button
              className="p-1"
              secondary
              icon
              labelPosition="left"
              onClick={() => {
                localStorage.removeItem("jwtToken");
                localStorage.removeItem("projectListData");
                localStorage.removeItem("playerEditingData");
              }}
            >
              <Icon name="angle double left" />
              Log out
            </Button>
          </Link>
        </div>
      </div>
    );
  }
}

TranslationsMain.propTypes = {};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(withRouter(TranslationsMain));



// WEBPACK FOOTER //
// ./src/components/translations/TranslationsMain.js